import { useMutation } from "@apollo/client";
import { DESTROY_PROFILE_ANSWER_MUTATION } from "@/api/mutations/destroyProfileAnswer";
import { useTranslation } from "react-i18next";

interface UseDestroyProfileAnswerOptions {
  onSuccess?: () => void;
  onError?: (error: string) => void;
}

export const useDestroyProfileAnswer = (
  options: UseDestroyProfileAnswerOptions = {},
) => {
  const { t } = useTranslation();
  const [destroyProfileAnswer, { loading }] = useMutation(
    DESTROY_PROFILE_ANSWER_MUTATION,
    {
      refetchQueries: ["ProfileQuestions", "ProfileAnswers"],
    },
  );

  const handleDestroyProfileAnswer = async (
    profileAnswerId: string,
    userId: string,
  ) => {
    try {
      const { data } = await destroyProfileAnswer({
        variables: {
          input: {
            profileAnswerId,
            userId,
          },
        },
      });

      const result = data?.destroyProfileAnswerMutation;

      if (result?.success) {
        options.onSuccess?.();
      } else {
        const errorMessage =
          result?.errors?.[0]?.message || t("profileAnswer.delete.error");
        options.onError?.(errorMessage);
      }
    } catch (error) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : t("profileAnswer.delete.error");
      options.onError?.(errorMessage);
    }
  };

  return {
    destroyProfileAnswer: handleDestroyProfileAnswer,
    loading,
  };
};
